<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Perfil
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                :value="content.nome"
                label="Perfil*"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-col cols="12">
              <span class="small">Permissões por Abas*</span>
              <div v-for="grupos in this.content.grupos" :key="grupos.id">
                <v-card class="border">
                  <v-card-title>
                    <v-icon class="grupos" small>mdi-account-group</v-icon>{{ grupos.nomeDeExibicao }}
                  </v-card-title>
                  <v-chip-group active-class="primary--text" column>
                    <v-chip v-for="permissao in grupos.permissoes" :key="permissao.id">
                      <v-icon class="grupos" small>mdi-ticket-percent</v-icon>{{ permissao.nomeDeExibicao }}
                    </v-chip>
                  </v-chip-group>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Perfil } from '~/commons/classes/perfil';

export default {
  props: new DialogProps(Perfil),
};
</script>
<style scoped>
.grupos {
  padding-right: 0.5em;
}
.border {
  border: 1px solid #9e9e9e;
  box-shadow: none !important;
}
</style>
